<template src="./Index.html">
</template>


<script>
import AddView from './actions/Add.vue';
import EditView from "./actions/Edit.vue";
import DetailsView from "./actions/Details.vue";

export default {
  components: {
    AddView,
    EditView,
    DetailsView,
  },
  created() {
    this.$store.dispatch("lookups/getDoctors");
    this.getAll();
  },
  computed: {
    doctors() {
      return [
        ...this.$store.state.lookups.doctors];
    },
    pageCount() {
      return Math.ceil(
        this.$store.state.patientsProcedures.totalItems / this.filters.pageSize
      );
    },
    patients() {
      return this.$store.state.patientsProcedures.patients;
    },

  },

  data() {
    return {
      permissions: this.$patientsManagementPermissions.PatientsProceduresPermissions,

      view: 0,

      dialog: false,
      dialogType: null,
      dialogMessage: "",

      filters: {
        page: 1,
        pageSize: 10,
        doctorId: null,

        fullName: null,
        phoneNo: null,
      },
      headers: [
        { text: 'رقم الملف', value: 'fileNo' },
        { text: 'الاسم ', value: 'fullName' },
        // { text: 'الجنس', value: 'gender' },
        { text: ' تاريخ الميلاد', value: 'birthDate' },
        // { text: 'رقم الهاتف', value: 'phone' },
        { text: 'الاجراءات', value: 'actions', sortable: false },
      ],
      list: [
        { label: "1", value: 1 }
      ],
      itemId: 0,
    };
  },
  methods: {
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("patientsProcedures/getAll", this.filters);

    },
    addItem() {
      this.view = 1;
    },
    viewItem(item) {
      this.itemId = item.id;
      this.view = 3;
    },
    editItem(item) {
      this.itemId = item.id;
      this.view = 2;
    },
  
    back() {
      this.view = 0;
    }
  },
};
</script>

<style scoped></style>